import { createSlice } from '@reduxjs/toolkit';
import { transformAppLevelPermissions } from '../../utils/Utils';

export const CommonStoreKey = 'CommonStore';

const initialState = {
    linkParams: {
        lang: '',
        uniquelink: '',
        uniquekey: '',
        environment: '',
        xpLang: '',
        pageName: '',
        modeId: '',
        tenant: ''
    },
    selectedLanguage: null,
    userRole: null,
    pagePermissions: null,
    appLevelPermissions: null
};

const policySlice = createSlice({
    name: CommonStoreKey,
    initialState: initialState,
    reducers: {
        addLinkParamsInStore: (state, action) => ({
            ...state,
            linkParams: { ...state.linkParams, ...action.payload }
        }),
        addAllRefPCPClinAndActonPopUpOpenInStore: (state, action) => ({
            ...state,
            AllRefPCPClinAndActonPopupValues: action.payload
        }),
        addAllRefPCPAndACtionPlanDetailsInStore: (state, action) => ({
            ...state,
            AllRefPcpAndActionPlanValues: action.payload
        }),
        updateSelectedLanguageInStore: (state, action) => ({
            ...state,
            selectedLanguage: action.payload
        }),
        updateUserRoleInStore: (state, action) => ({
            ...state,
            userRole: action.payload
        }),
        insertPagePermission: (state, action) => {
            const rolePermissions = action.payload?.rolePermissions;
            const appPermissions = action.payload?.appPermissions || [];
            const appLevelPermissions =
                appPermissions?.length > 0 ? transformAppLevelPermissions(appPermissions) : state.appLevelPermissions;

            return {
                ...state,
                pagePermissions: action.payload === true ? state.pagePermissions : rolePermissions,
                appLevelPermissions: appLevelPermissions
            };
        },
        clearPagePermission: (state) => ({
            ...state,
            pagePermissions: {}
        }),
        resetCommonStore: (state) => ({
            ...initialState
        })
    }
});

const { actions, reducer: commonReducer } = policySlice;
export const {
    addLinkParamsInStore,
    addAllRefPCPClinAndActonPopUpOpenInStore,
    addAllRefPCPAndACtionPlanDetailsInStore,
    updateSelectedLanguageInStore,
    updateUserRoleInStore,
    insertPagePermission,
    clearPagePermission,
    resetCommonStore
} = actions;
export default commonReducer;
